import {
  ChatIconButton,
  Logo,
  ProfileMenu,
  NotificationMenu,
  MobileHeader,
  MobileProfileMenu,
} from "@/components/Header";
import { usePersonalDetailsQuery } from "@/fetch/profiles";
import { useRouter } from "next/router";
import Avatar from "@/components/Avatar";
import { IconButton } from "@/components/Button";
import { Skeleton } from "@/components/Loader";
import { SearchIcon } from "@/components/Icon";
import styles from "./AcademyMobileHeader.module.scss";
import { useRoutes, useFilterStatus } from "@/hooks";
import Typography from "@/components/Typography";

const AcademyMobileHeader: React.FC = () => {
  const router = useRouter();
  const { data: personalDetails, isLoading: isPersonalDetailsLoading } =
    usePersonalDetailsQuery();
  const profilePictureCloudinaryPath =
    personalDetails?.traveller?.s3_profile_pic;
  const { hasAccessToRoute } = useRoutes();
  const hasSocialAccess = hasAccessToRoute("Social");
  const { setIsFilterOpen } = useFilterStatus();

  return (
    <MobileHeader className={styles.header}>
      <MobileProfileMenu />
      <div className={styles.textContainer}>
        <Typography variant="h5" className={styles.title}>
          Learn
        </Typography>
      </div>
      <IconButton
        onClick={() => setIsFilterOpen(true)}
        className={styles.iconButton}
      >
        <SearchIcon />
      </IconButton>
      <NotificationMenu />
    </MobileHeader>
  );
};
export default AcademyMobileHeader;
